var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 13.8672C13.5782 13.8672 14.8581 15.1471 14.8581 16.7259V21.9372H9.14062V16.7259C9.14062 15.1471 10.4205 13.8672 11.9994 13.8672Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28516 14.5203L10.701 3.59789C11.3849 2.80461 12.614 2.80461 13.2979 3.59789L22.7137 14.5203",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6991 3.57919L4.58235 10.7055L4.23296 13.198C3.91814 15.444 3.93355 17.7239 4.27874 19.9655C4.45342 21.0999 5.42948 21.9371 6.57717 21.9371H17.4226C18.5703 21.9371 19.5465 21.0999 19.7211 19.9655C20.0662 17.7239 20.0817 15.444 19.7669 13.198L19.4175 10.7055L13.3007 3.57919C12.6166 2.78219 11.3832 2.7822 10.6991 3.57919ZM14.8587 16.7257C14.8587 15.1469 13.5788 13.867 11.9999 13.867C10.4211 13.867 9.14119 15.1469 9.14119 16.7257V21.937H14.8587V16.7257Z",
    fill: "#B6C0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58235 10.7055L10.6991 3.5792C11.3832 2.78219 12.6167 2.78219 13.3007 3.5792L19.4176 10.7055L19.7669 13.198C20.0817 15.444 20.0662 17.724 19.7212 19.9656C19.5465 21.1 18.5704 21.9372 17.4226 21.9372H6.57716C5.42948 21.9372 4.45342 21.1 4.27873 19.9656C3.93356 17.724 3.91813 15.444 4.23296 13.198L4.58235 10.7055Z",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 13.8672C13.5782 13.8672 14.8581 15.1471 14.8581 16.7259V21.9372H9.14062V16.7259C9.14062 15.1471 10.4205 13.8672 11.9994 13.8672Z",
    stroke: "#18202F",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.b813792e357b347748362217cb66f2ba.svg";
export { ForwardRef as ReactComponent };